<div class="d-flex flex-column flex-md-row h-100 position-relative overflow-hidden">

  <div class="text-section text-white d-flex flex-column justify-content-center p-4 flex-shrink-0">
    <h2 class="d-block d-sm-none fs-4 fw-bold">Happy National Microchipping Month!</h2>
    <h2 class="fs-4 fw-bold">Check your microchip details<br>for the chance to win!</h2>
    <a 
      href="https://identiblog.zendesk.com/hc/en-us/articles/27705837507741-Win-Prizes-This-National-Microchipping-Month"
      target="_blank"
      class="btn btn-lg btn-light fw-bold mt-4 px-4 py-2 rounded-pill">
      Find out more
    </a>
  </div>

  <div class="image-section position-relative w-100">
    <img 
      src="assets/images/home/nmm-slide-image.jpeg"
      alt="National Microchipping Month - Cat and dog"
      class="w-100 h-100 object-fit-cover"
      width="650"
      height="400"
    />
    
    <div class="gradient-overlay position-absolute top-0 start-0"></div>
    
    <div class="badge-overlay d-none d-sm-flex flex-column align-items-center justify-content-center bg-white position-absolute top-0 end-0 m-3 text-center fw-bold">
      <span class="position-relative">Happy<br>National<br>Microchipping<br>Month!</span>
    </div>
  </div>
</div>
